
import "./ErrorMessage.css";
import { ReactComponent as ErrorIcon } from "../../assets/icons/error-state.svg";

export type ErrorMessageProps = {
    msg: any;
};

const ErrorMessage = ({msg}: ErrorMessageProps) => {
    return (
        <div className="empty-data-container">
            <div className="empty-data-spinner">
                <ErrorIcon />
                <div className="empty-data-text">{msg ? msg.label : ''}</div>
            </div>
        </div>        
    );
};
export default ErrorMessage;